"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _default = function _default() {
  var position = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'center';

  switch (position) {
    case 'left':
      return "\n        margin-right: auto;\n        margin-left: 0;\n      ";

    case 'right':
      return "\n        margin-left: auto;\n        margin-right: 0;\n      ";

    default:
      return "\n        margin: auto;\n      ";
  }
};

exports.default = _default;